import { faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import VoxelButton from '../../../../../components/voxel/Buttons/VoxelButton';
import { VoxelPopover } from '../../../../../components/voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../../components/voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../../components/voxel/Popover/VoxelPopoverTrigger';
import VoxelMenuItemContainer from '../../../../../components/voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelPopoverMenuItem from '../../../../../components/voxel/PopoverMenu/VoxelPopoverMenuItem';
import VoxelTooltipShort from '../../../../../components/voxel/Tooltip/VoxelTooltipShort';
import { ContentTaskFilteringGq } from '../../../../../graphql/projects/models/ContentTaskFilteringGq';
import { ContentTaskStatusGq } from '../../../../../graphql/projects/models/ContentTaskStatusGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';

export interface ContentPlanDownloadButtonProps {
  projectId: number;
  filter: ContentTaskFilteringGq;
  disabled: boolean;
}

export const ContentPlanDownloadButton: React.FC<ContentPlanDownloadButtonProps> = ({
  projectId,
  disabled,
  filter,
}) => {
  const downloadMutation = projectsApiService.mutations.contentPlan.useDownloadContentPlan();
  const [downloading, setDownloading] = useState(false);
  const handleDownload = useCallback(
    (type: 'all' | 'approved-only' | 'filter') => {
      setDownloading(true);
      downloadMutation({
        projectId: projectId,
        approvedStatus: type === 'approved-only' ? ContentTaskStatusGq.APPROVED : undefined,
        filtering: type === 'filter' ? filter : undefined,
      })
        .then((result) => {
          window.location.href = result.downloadUrl;
        })
        .finally(() => setDownloading(false));
    },
    [projectId, filter]
  );

  return (
    <VoxelPopover>
      <VoxelPopoverTrigger>
        <VoxelButton
          title={'export'}
          tooltip="Export content plan"
          size={'md'}
          color={'light-gray'}
          endIcon={
            downloading ? <CircularProgress size={18} /> : <FontAwesomeIcon icon={faFileExport} />
          }
        />
      </VoxelPopoverTrigger>
      <VoxelPopoverContent>
        <VoxelMenuItemContainer>
          <VoxelPopoverMenuItem
            onClick={() => handleDownload('all')}
            title="All"
            disabled={disabled}
          />
          <VoxelPopoverMenuItem
            onClick={() => handleDownload('approved-only')}
            title="Approved only"
            disabled={disabled}
          />
          <VoxelPopoverMenuItem
            onClick={() => handleDownload('filter')}
            title="Currently filtered"
            disabled={disabled}
          />
        </VoxelMenuItemContainer>
      </VoxelPopoverContent>
    </VoxelPopover>
  );
};

export default ContentPlanDownloadButton;
